export interface FairBarInfo {
	id: number;
	name: string;
	fairStartDate: string;
	fairEndDate: string;
}

export const defaultFairBarInfo: FairBarInfo = {
	id: 0,
	name: '',
	fairStartDate: '',
	fairEndDate: '',
};
